import React, { useEffect, useState } from 'react';
import { ServiceGridContainer, LoadingContainer, Container, SubTitle } from './styles.js';
import Load from '../../../components/load/index.js';
import Movie from '../../../components/movie/index.js';
import { Swiper, SwiperSlide } from "swiper/react";
import BandeiraBrasil from "../../../components/images/bandeira-brasil.png";
import { convertDate } from '../../../components/convert-date/index.js';
import Watching from './watching/index.js';

// Função para embaralhar um array
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

const fetchMoviesForSection = async (movies, section) => {
    if (Array.isArray(movies?.movies)) {
        const filteredMovies = movies.movies.filter(movie =>
                movie?.tags?.some(tag => section.tags.includes(tag)) &&
                !movie?.tags?.some(tag => section.ignoreTags.includes(tag))
            ).sort((a, b) => (b.tags?.includes("tag_new") - a.tags?.includes("tag_new"))
        );

        return { title: section.title, movies: filteredMovies };
    }
    return { title: section.title, movies: [] };
};

const Movies = ({ user, movies, moviesWatching, setGetMoviesWatching }) => {

    const [date, setDate] = useState(null);

    const [loadingMovies, setLoadingMovies] = useState(false);
    const [allMovies, setAllMovies] = useState(null);
    const [sectionsData, setSectionsData] = useState([]);
    const [visibleMovies, setVisibleMovies] = useState({});
    const [batchSize] = useState(10);

    const sections = [
        { title: 'Ação', tags: [1], ignoreTags: [14, 2, 25, 7] },
        { title: 'Comédia', tags: [7], ignoreTags: [2] },
        { title: 'Terror', tags: [26], ignoreTags: [4] },
        { title: 'Ficção', tags: [14, 29], ignoreTags: [] },
        { title: 'Brasileiros', tags: [6], ignoreTags: [] },
        { title: 'Drama', tags: [11], ignoreTags: [6, 5, 39, 17] },
        { title: 'Suspense e Mistério', tags: [39, 17], ignoreTags: [26] },
        { title: 'Jogos Mortais', tags: [40], ignoreTags: [] },
        //{ title: 'Drama Médico', tags: [28], ignoreTags: [] },
        { title: 'Animações', tags: [2], ignoreTags: [51] },
        //{ title: 'Animes', tags: [51], ignoreTags: [] },
        { title: 'Carros', tags: [31], ignoreTags: [] },
        { title: 'Documentários', tags: [10], ignoreTags: [] },
        { title: 'Baseado em Fatos Reais', tags: [5], ignoreTags: [] },
        //{ title: 'Teen', tags: [25], ignoreTags: [] },
        //{ title: 'Adaptações de Videogames', tags: [42], ignoreTags: [] },
        { title: 'Romance', tags: [46], ignoreTags: [] },
        { title: 'Apocalipse', tags: [4], ignoreTags: [] },
        //{ title: 'Para toda a família', tags: [21], ignoreTags: [] },
        //{ title: 'Lutas', tags: [44], ignoreTags: [2] },
        { title: 'Robôs', tags: [45], ignoreTags: [] },
        //{ title: 'Natal', tags: [52], ignoreTags: [] },
    ];

    const loadSections = async () => {
        if (!movies || !Array.isArray(movies?.movies) || movies.movies.length === 0) return;

        setLoadingMovies(true);
        setAllMovies(movies);

        const allSectionsData = await Promise.all(
            sections.map(section => fetchMoviesForSection(movies, section))
        );

        const updatedSectionsData = [];
        const moviesAlreadySeen = new Set();

        allSectionsData.forEach(sectionData => {
            let { movies } = sectionData;
            movies = shuffleArray(movies);

            const uniqueMovies = [];
            const repeatedMovies = [];

            movies.forEach(movie => {
                if (moviesAlreadySeen.has(movie.id)) {
                    repeatedMovies.push(movie);
                } else {
                    uniqueMovies.push(movie);
                    moviesAlreadySeen.add(movie.id);
                }
            });

            updatedSectionsData.push({
                ...sectionData,
                movies: [...uniqueMovies, ...repeatedMovies],
            });
        });

        const initialVisibleMovies = {};
        updatedSectionsData.forEach(data => {
            initialVisibleMovies[data.title] = data.movies.slice(0, batchSize);
        });

        setSectionsData(updatedSectionsData);
        setVisibleMovies(initialVisibleMovies);
        setLoadingMovies(false);
    };

    const loadMoreMovies = (sectionTitle) => {
        const section = sectionsData.find(sec => sec.title === sectionTitle);
        if (!section) return;

        const currentVisibleMovies = visibleMovies[sectionTitle] || [];
        const nextBatch = section.movies.slice(
            currentVisibleMovies.length,
            currentVisibleMovies.length + batchSize
        );

        setVisibleMovies(prev => ({
            ...prev,
            [sectionTitle]: [...currentVisibleMovies, ...nextBatch],
        }));
    };

    useEffect(() => {
        loadSections();
        
        setDate(new Date());
    }, [movies]);

    useEffect(()=>{
        if (user) {
            setGetMoviesWatching(true);
        }
    }, [ user ])

    if (!movies || !Array.isArray(movies?.movies) || movies.movies.length === 0) {
        return <Load align_center={true} />;
    }

    return (
        <Container>
            <Watching user={user} movies={moviesWatching} setGetMoviesWatching={setGetMoviesWatching}/>
            {sectionsData.length > 0 ? (
                sectionsData?.slice(0, 3).map((section, index) => (
                    <div key={index}>
                        <SubTitle>
                            {section.title}
                            {section.title === "Brasileiros" && <img src={BandeiraBrasil} alt="Bandeira do Brasil" />}
                        </SubTitle>
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={0}
                            freeMode={false}
                            onReachEnd={() => loadMoreMovies(section.title)}
                            pagination={{ clickable: true }}
                            className="div-movies"
                        >
                            {section.movies.length > 0 && (
                                section.movies?.slice(0, 10).map((movie, idx) => (
                                    <SwiperSlide key={`${movie.id}-${idx}`}>
                                        <ServiceGridContainer>
                                            <Movie movie={movie} date={date} index={idx} />
                                        </ServiceGridContainer>
                                    </SwiperSlide>
                                ))
                            )}
                        </Swiper>
                    </div>
                ))
            ) : (
                <Load align_center={true} />
            )}

            {loadingMovies && (
                <LoadingContainer>
                    <Load />
                </LoadingContainer>
            )}
            {allMovies?.updated && (
                <span className='span-updated'>*Filmes atualizados em: {convertDate(allMovies?.updated?.seconds * 1000 || null, true)}</span>
            )}
        </Container>
    );
};

export default Movies;
